import { MRT_SortingState } from 'mantine-react-table';
import { useURLandLocalStorageSortingState } from './usePersistentStates';

interface TableSortingConfig {
  tableId: string;
  defaultSortColumn: string;
  defaultSortDirection?: 'asc' | 'desc';
}

interface SortParameters {
  sortColumn?: string;
  sortType?: -1 | 1;
}

export const useTableSorting = ({
  tableId,
  defaultSortColumn,
  defaultSortDirection = 'desc',
}: TableSortingConfig) => {
  const defaultState: MRT_SortingState = [
    {
      id: defaultSortColumn,
      desc: defaultSortDirection === 'desc',
    },
  ];

  const [sorting, setSorting] = useURLandLocalStorageSortingState(tableId, defaultState);

  const getSortParameters = (): SortParameters => {
    const currentSort = sorting[0];
    if (!currentSort) return {};

    return {
      sortColumn: currentSort.id,
      sortType: currentSort.desc ? -1 : 1,
    };
  };

  return {
    sorting,
    setSorting,
    getSortParameters,
  };
};
